import React, { useState, useRef, useEffect } from 'react';
import { css } from 'emotion';
import { CaretRight } from 'phosphor-react';
import { Tooltip } from '@mui/material';
import { ReactComponent as ListIconSVG } from '../images/svg/list-icon.svg';
import { Colors } from '@be-brite/briteui'

export const PageDrawerToggle = ({ pages, setCurrentPageIndex, currentPageIndex, setOpen, open, designStyles }) => {
  const [shouldShowList, setShouldShowList] = useState(false);
  const timeoutRef = useRef(null);
  const listRef = useRef(null);
  const containerRef = useRef(null);

  const handleMouseEnter = () => {
    setShouldShowList(true);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  const handleMouseLeave = (e) => {
    if (listRef.current) {
      const listRect = listRef.current.getBoundingClientRect();
      const mouseX = e.clientX;
      const mouseY = e.clientY;
      const containerRect = containerRef.current.getBoundingClientRect();

      if (
        mouseX > containerRect.right &&
        mouseX < listRect.right &&
        mouseY > listRect.top &&
        mouseY < listRect.bottom
      ) {
        return;
      }
    }

    timeoutRef.current = setTimeout(() => {
      setShouldShowList(false);
    }, 300);
  };

  const handleListMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setShouldShowList(true);
  };

  const handleListMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setShouldShowList(false);
    }, 300);
  };

  const handlePageClick = (index) => {
    setCurrentPageIndex(index);
    setShouldShowList(false);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={containerRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={css`
        position: fixed;
        top: 70px;
        left: 20px;
        z-index: 1002;
        transform: translateX(${open ? '-100%' : '0'});
        opacity: ${open ? '0' : '1'};
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      `}
    >
      <div
        className={css`
          background: #ffffff;
          border: 1px solid #d1dae3;
          border-radius: 7px;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          padding: 12px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          transform: translateX(${open ? '-20px' : '0'});
        `}
      >
        <Tooltip title="Show pages" placement="right">
          <button
            className={css`
              background: none;
              border: none;
              padding: 0;
              cursor: pointer;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              border-radius: 0 4px 4px 0;
              transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
              transform: translateX(${open ? '-20px' : '0'});
              position: relative;
            `}
            aria-label="Toggle pages menu"
            onClick={() => setOpen(!open)}
          >
            <CaretRight
              color="#36414C"
              size={24}
              style={{
                marginBottom: '4px',
              }}
            />

            <ListIconSVG
              color="#36414C"
              size={24}
              style={{
                marginTop: '4px',
              }}
            />
          </button>
        </Tooltip>

        <div
          className={css`
            position: relative;
          `}
        >
          {/* {true && ( */}
          {shouldShowList && (
            <div
              ref={listRef}
              onMouseEnter={handleListMouseEnter}
              onMouseLeave={handleListMouseLeave}
              className={css`
                position: absolute;
                left: -20px;
                top: -60px; /* Align with the list icon */
                background: white;
                border-radius: 4px;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                max-height: 80vh;
                width: 340px;
                overflow-x: hidden;
                overflow-y: auto;
                text-wrap: nowrap;
                z-index: 1000;
                animation: fadeIn 0.2s ease forwards;

                @keyframes fadeIn {
                  from {
                    opacity: 0;
                    transform: translateX(-10px);
                  }
                  to {
                    opacity: 1;
                    transform: translateX(0);
                  }
                }
              `}
            >
              {pages?.map((page, index) => (
                <button
                  key={index}
                  onClick={() => handlePageClick(index)}
                  className={css`
                    width: 100%;
                    text-align: left;
                    padding: 12px 16px;
                    background: ${currentPageIndex === index ? Colors.Gray200 : 'transparent'};
                    border: none;
                    cursor: pointer;
                    font-family: 'Roboto', sans-serif;
                    font-size: 14px;
                    line-height: 1.4;
                    color: '#25282D';
                    transition: all 0.2s ease;
                    display: flex;
                    align-items: center;
                    gap: 8px;

                    &:hover {
                      background: ${Colors.Gray200};
                      transform: translateX(2px);
                    }
                  `}
                >
                  <span
                    className={css`
                      width: 24px;
                      height: 24px;
                      border-radius: 50%;
                      background: ${index === currentPageIndex ? '#fff2' : Colors.Gray200};
                      color: '#66737F';
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      font-size: 12px;
                      font-weight: 500;
                      transition: all 0.2s ease
                    `}
                  >
                    {index + 1}
                  </span>
                  {page.Title || page.Name}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
